import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "flex-column-box digital-market-page"
};
const _hoisted_2 = {
  class: "header-box"
};
const _hoisted_3 = {
  class: "header-segment"
};
const _hoisted_4 = {
  class: "segment-item"
};
const _hoisted_5 = {
  class: "header"
};
const _hoisted_6 = {
  key: 0,
  class: "type-wrap radius-middle right"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 0,
  class: "flex-row-box",
  style: {
    "flex-wrap": "wrap",
    "width": "100%",
    "height": "100px",
    "flex-grow": "2",
    "overflow": "auto",
    "justify-content": "flex-start",
    "align-items": "flex-start"
  }
};
const _hoisted_9 = ["onMouseenter", "onMouseleave"];
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "digital-man-name"
};
const _hoisted_12 = {
  class: "svg-icon vip-tag"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  key: 1,
  class: "flex-row-box",
  style: {
    "flex-wrap": "wrap",
    "width": "100%",
    "overflow": "auto",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "min-height": "200px"
  }
};
const _hoisted_15 = {
  class: "flex-column-box audio-item"
};
const _hoisted_16 = {
  class: "audio-item-img"
};
const _hoisted_17 = {
  class: "audio-item-name"
};
const _hoisted_18 = {
  class: "audio-item-desc"
};
const _hoisted_19 = {
  class: "svg-icon vip-tag"
};
const _hoisted_20 = {
  class: "audio-btn"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  style: {
    "width": "100%",
    "height": "50px",
    "margin-top": "10px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_23 = ["src", "height"];
import { ref, onMounted, nextTick, onBeforeUnmount } from 'vue';
import { getAppVirtualManMarketPage, deleteAppUserCollectByType, addAppUserCollect, getAppTimbreMarketPage } from '@/request/index.ts';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import { Star } from '@element-plus/icons-vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const handleClose = () => {
      previewSrc.value = '';
    };
    const loading = ref(false);
    const tabs = ref([{
      label: '形象',
      value: 1,
      icon: 'ri-robot-3-line'
    }, {
      label: '音色',
      value: 2,
      icon: 'ri-music-2-line'
    }]);
    const activeTab = ref(1);
    const toggleTab = value => {
      activeTab.value = value;
      currentPage.value = 1;
      nextTick(() => {
        get2DData();
      });
    };
    const types = ref([{
      label: '1920x1080',
      value: '1920x1080'
    }, {
      label: '1280x720',
      value: '1280x720'
    }, {
      label: '1080x1920',
      value: '1080x1920'
    }, {
      label: '720x1280',
      value: '720x1280'
    }]);
    const activeType = ref('1920x1080');
    const toggleType = (value, type) => {
      activeType.value = value;
      currentPage.value = 1;
      get2DData();
    };
    const STAR_TYPE = {
      MAN: 1,
      AUDIO: 2
    };
    const toggleStar = (man, starType) => {
      if (man.isCollect == 1) {
        deleteAppUserCollectByType({
          type: starType,
          businessId: man.id
        }).then(res => {
          const {
            code
          } = res.data;
          if (code === 200) {
            ElMessage.success('取消成功');
            get2DData();
          }
        });
      } else {
        addAppUserCollect({
          type: starType,
          businessId: man.id
        }).then(res => {
          const {
            code
          } = res.data;
          if (code === 200) {
            ElMessage.success('收藏成功');
            get2DData();
          }
        });
      }
    };
    const digitalManList = ref([]);
    const getDigitalManList = () => {
      return digitalManList.value.filter(item => {
        var _item$resolution;
        return ((_item$resolution = item.resolution) === null || _item$resolution === void 0 ? void 0 : _item$resolution.indexOf(activeType.value)) !== -1;
      });
    };
    const total = ref(0);
    const currentPage = ref(1);
    const handlePageChange = val => {
      currentPage.value = val;
      get2DData();
    };
    // 获取2D
    const get2DData = () => {
      try {
        loading.value = true;
        if (activeTab.value === 1) {
          getAppVirtualManMarketPage({
            pageIndex: currentPage.value,
            pageSize: 12,
            resolution: activeType.value
          }).then(res => {
            const {
              data
            } = res.data;
            digitalManList.value = data.list || [];
            total.value = data.total || 0;
          });
        } else {
          getAppTimbreMarketPage({
            pageIndex: currentPage.value,
            pageSize: 12
          }).then(res => {
            const {
              data
            } = res.data;
            digitalManList.value = data.list || [];
            total.value = data.total || 0;
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        loading.value = false;
      }
    };
    const gotoAdd = man => {
      if (man.canUse == 0) return ElMessage.error('当前用户无权限使用，请联系客服!');
      // router.push({
      //   path: '/new-video',
      //   query: {
      //     virtualManKey: man.virtualManKey,
      //   },
      // });
      let urlParams = new URLSearchParams();
      if (man.virtualManKey) urlParams.set('virtualManKey', man.virtualManKey);
      window.location.href = `${window.origin}/design/#/?${urlParams.toString()}`;
    };
    const dialogVisible = ref(false);
    const previewSrc = ref('');
    const dialogTitle = ref('');
    const openDialog = (man, type) => {
      if (type === 'audio') {
        dialogVisible.value = true;
        dialogTitle.value = man.anchorName;
        previewSrc.value = man.timbreSample;
        return;
      }
      if (!man.referenceVideoSegmentUrl) return ElMessage.error('该形象暂无可预览视频');
      dialogVisible.value = true;
      dialogTitle.value = man.anchorName;
      previewSrc.value = man.referenceVideoSegmentUrl || man.timbreSample;
    };
    const videoRefs = ref({});
    const loadingStates = ref({});
    const videoLoadedMap = ref({});
    // 添加定时器变量
    const hoverTimer = ref(null);
    // 修改鼠标进入处理函数
    const handleMouseEnter = man => {
      // 设置100ms延迟
      hoverTimer.value = setTimeout(() => {
        handleVideoPlay(man);
      }, 100);
    };
    // 修改鼠标离开处理函数
    const handleMouseLeave = async man => {
      // 清除定时器
      if (hoverTimer.value) {
        clearTimeout(hoverTimer.value);
        hoverTimer.value = null;
      }
      if (!man.referenceVideoSegmentUrl) return;
      // 重置所有数字人的播放状态
      digitalManList.value.forEach(item => {
        item.isPlaying = false;
        const video = videoRefs.value[item.id];
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
        loadingStates.value[item.id] = false;
      });
    };
    // 修改handleVideoPlay函数的实现
    const handleVideoPlay = async man => {
      if (!man.referenceVideoSegmentUrl) return;
      // 只有视频未加载过时才显示loading
      if (!videoLoadedMap.value[man.id]) {
        loadingStates.value[man.id] = true;
        try {
          // 预加载视频
          const video = videoRefs.value[man.id];
          if (video) {
            video.src = man.referenceVideoSegmentUrl;
            await new Promise(resolve => {
              video.onloadeddata = () => {
                videoLoadedMap.value[man.id] = true;
                resolve(true);
              };
            });
          }
        } catch (error) {
          console.error('视频加载失败:', error);
        } finally {
          loadingStates.value[man.id] = false;
        }
      }
      man.isPlaying = true;
      await nextTick();
      const video = videoRefs.value[man.id];
      if (video) {
        video.currentTime = 0;
        try {
          await video.play();
        } catch (error) {
          console.error('视频播放失败:', error);
        }
      }
    };
    // 在组件卸载时清理视频资源
    onBeforeUnmount(() => {
      Object.values(videoRefs.value).forEach(video => {
        if (video) {
          video.src = '';
          video.load();
        }
      });
      videoLoadedMap.value = {};
    });
    onMounted(() => {
      get2DData(1);
    });
    return (_ctx, _cache) => {
      const _component_el_segmented = _resolveComponent("el-segmented");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_image = _resolveComponent("el-image");
      const _component_svgIcon = _resolveComponent("svgIcon");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "header-title"
      }, "选择你想要的数字人", -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_segmented, {
        size: "small",
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeTab.value = $event),
        options: tabs.value,
        onChange: toggleTab
      }, {
        default: _withCtx(scope => [_createElementVNode("div", _hoisted_4, [_createElementVNode("i", {
          class: _normalizeClass(scope.item.icon)
        }, null, 2), _createTextVNode(" " + _toDisplayString(scope.item.label), 1)])]),
        _: 1
      }, 8, ["modelValue", "options"])])]), _createElementVNode("div", _hoisted_5, [activeTab.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, item => {
        return _openBlock(), _createElementBlock("a", {
          class: _normalizeClass(["type-item", activeType.value == item.value && 'active']),
          key: item.value,
          onClick: $event => toggleType(item.value, item.type)
        }, _toDisplayString(item.label), 11, _hoisted_7);
      }), 128))])) : _createCommentVNode("", true)]), activeTab.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDigitalManList(), (man, idx) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "digital-man-outer",
          key: idx
        }, [_createElementVNode("div", {
          class: "digital-man-wrap radius-middle",
          onMouseenter: $event => handleMouseEnter(man),
          onMouseleave: $event => handleMouseLeave(man)
        }, [_createVNode(_component_el_button, {
          class: "star",
          onClick: $event => toggleStar(man, STAR_TYPE.MAN),
          type: man.isCollect == 1 ? 'warning' : 'info',
          icon: _unref(Star),
          circle: ""
        }, null, 8, ["onClick", "type", "icon"]), _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["video-container", {
            show: man.isPlaying
          }]),
          "element-loading-text": "视频加载中...",
          style: _normalizeStyle({
            display: man.isPlaying ? 'flex' : 'none'
          })
        }, [man.referenceVideoSegmentUrl ? (_openBlock(), _createElementBlock("video", {
          key: 0,
          ref_for: true,
          ref: el => {
            if (el) videoRefs.value[man.id] = el;
          },
          class: "preview-video",
          src: man.isPlaying ? man.referenceVideoSegmentUrl : '',
          muted: "",
          loop: ""
        }, null, 8, _hoisted_10)) : _createCommentVNode("", true)], 6)), [[_directive_loading, loadingStates.value[man.id]]]), _createVNode(_component_el_image, {
          src: man.poseImage,
          fit: "scale-down",
          style: _normalizeStyle({
            position: 'absolute',
            bottom: '0px',
            height: '100%',
            width: '100%',
            display: man.isPlaying ? 'none' : 'flex',
            alignItems: 'flex-end',
            pointerEvents: 'none',
            userSelect: 'none'
          })
        }, null, 8, ["src", "style"]), _createElementVNode("div", _hoisted_11, _toDisplayString(man.anchorName), 1), _createElementVNode("a", _hoisted_12, _toDisplayString(man.minMemberBenefitName), 1), _createElementVNode("div", {
          class: "hover-btn",
          onClick: $event => gotoAdd(man)
        }, "创建视频", 8, _hoisted_13)], 40, _hoisted_9)])), [[_directive_loading, loading.value]]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(digitalManList.value, audio => {
        return _openBlock(), _createElementBlock("div", {
          class: "audio-item-wrap",
          key: audio.timbreKey
        }, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_button, {
          class: "star",
          size: "small",
          onClick: $event => toggleStar(audio, STAR_TYPE.AUDIO),
          type: audio.isCollect == 1 ? 'warning' : 'info',
          icon: _unref(Star),
          circle: ""
        }, null, 8, ["onClick", "type", "icon"]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
          class: "btn-wrap",
          style: _normalizeStyle({
            display: audio.play ? 'flex' : 'none'
          })
        }, [_createVNode(_component_svgIcon, {
          iconClass: audio.play ? 'pusewhite' : 'play',
          width: "24px",
          height: "24px"
        }, null, 8, ["iconClass"])], 4), _createVNode(_component_svgIcon, {
          iconClass: "voicecolor",
          width: "24px",
          height: "24px"
        })]), _createElementVNode("p", _hoisted_17, _toDisplayString(audio.timbreName), 1), _createElementVNode("p", _hoisted_18, _toDisplayString(audio.timbreDesc), 1), _createElementVNode("a", _hoisted_19, _toDisplayString(audio.minMemberBenefitName), 1)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("a", {
          class: "radius-middle",
          onClick: $event => openDialog(audio, 'audio')
        }, "预览", 8, _hoisted_21)])]);
      }), 128))])), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_pagination, {
        layout: "prev, pager, next",
        total: total.value,
        "current-page": currentPage.value,
        "page-size": 12,
        onCurrentChange: handlePageChange
      }, null, 8, ["total", "current-page"])]), _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogVisible.value = $event),
        title: dialogTitle.value,
        width: "632",
        center: "",
        onClose: handleClose
      }, {
        default: _withCtx(() => [_createElementVNode("video", {
          src: previewSrc.value,
          autoplay: "",
          width: "600px",
          height: activeTab.value === 1 ? '400px' : '70px',
          controls: ""
        }, null, 8, _hoisted_23)]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
});